import React, { useEffect } from 'react'
import { OptionModel } from '../common/types/OptionModel'
import { ApiResponseType } from '../common/api/apiHelper';
import commonNetwork from '../common/api/commonNetwork';
import { toast } from 'react-toastify';

const useGetCustomerName = (
    setCustomerOptions: (options: OptionModel[]) => void,
    setLoadingDataOptions: (loading: boolean) => void,
) => {
    useEffect(() => {
      const fetchCustomerName = async () => {
        try {
          setLoadingDataOptions(true)
          let result: ApiResponseType;
          result = await commonNetwork.get("/customer/get-customername-options"); 
          if (result.isSuccess) {
            const customerData = result.data;
            const options: OptionModel[] = customerData.map((item: any) => ({
              value: item.customerId,
              label: item.customerCode ? item.customerName + " - " + item.customerCode : item.customerName
            }));
            setCustomerOptions(options);
          } else {
            toast.error(result.errorMessage);
          }
        } catch (error) {
     
        } finally {
          setLoadingDataOptions(false)
        }
      }
      fetchCustomerName();
    }, [])
}

export default useGetCustomerName